<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="add-shift-modal" (click)="onModalClick($event)">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ editMode ? 'Edit Shift' : 'Add Shift' }}</h2>
      <button class="close-button" (click)="onClose()" [disabled]="isSubmitting">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3L3 9M3 3L9 9" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </button>
      </div>

      <!-- Header Divider for Mobile -->
      <div class="header-divider"></div>

      <!-- Modal Content -->
    <div class="modal-content">
      <!-- Loading Overlay -->
      <div class="loading-overlay" *ngIf="isLoadingShiftData">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading shift details...</p>
      </div>

      <!-- Shift Name Input -->
      <div class="shift-name-section">
        <label class="input-label">Shift Name<span class="required-asterisk">*</span></label>
        <input 
          type="text" 
          [(ngModel)]="shiftForm.shift_name"
          placeholder="Enter shift name"
          class="shift-name-input"
          [disabled]="isSubmitting"
          maxlength="100"
          (keydown)="onShiftNameKeydown($event)"
          (input)="onShiftNameInput($event)"
        >
        <!-- Error Message Display -->
        <div class="error-message" *ngIf="errorMessage || shiftNameError">
          {{ errorMessage || shiftNameError }}
        </div>
      </div>

      <!-- Divider after Shift Name -->
      <div class="section-divider"></div>

      <!-- Daily Schedule Section -->
      <div class="daily-schedule-section">
        <!-- Schedule Headers -->
        <div class="schedule-headers">
          <div class="header-cell days-header">Days</div>
          <div class="header-cell status-header">Status</div>
          <div class="header-cell time-headers-wrapper">
            <span class="header-time-cell">Start Time</span>
            <span class="header-separator"></span>
            <span class="header-time-cell">End Time</span>
          </div>
        </div>

        <!-- Divider after headers -->
        <div class="headers-divider"></div>

        <!-- Schedule Rows -->
        <div class="schedule-rows">
          <div *ngFor="let day of shiftForm.days; let i = index; trackBy: trackByIndex">
            <div class="schedule-row">
              <div class="day-cell">{{ day.day }}</div>
              <div class="status-cell">
                <label class="mobile-label">Status</label>
                <div class="custom-dropdown" [class.disabled]="isSubmitting">
                  <div class="dropdown-selected" (click)="toggleStatusDropdown(i)" [class.disabled]="isSubmitting">
                    <span class="selected-value">{{ day.status }}</span>
                    <svg class="dropdown-arrow" [class.rotated]="openStatusDropdown === i" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
                    </svg>
                  </div>
                  <div class="dropdown-menu" [class.show]="openStatusDropdown === i">
                    <div class="dropdown-option" 
                         [class.selected]="day.status === 'Working'"
                         (click)="onDayStatusChange(i, 'Working')">
                      Working
                    </div>
                    <div class="dropdown-option" 
                         [class.selected]="day.status === 'Day off'"
                         (click)="onDayStatusChange(i, 'Day off')">
                      Day off
                    </div>
                  </div>
                </div>
              </div>
              <div class="time-fields-container" *ngIf="day.status === 'Working'">
                <div class="start-time-cell">
                  <label class="mobile-label">Start Time</label>
                  <div class="custom-dropdown" [class.disabled]="isSubmitting">
                    <div class="dropdown-selected" (click)="toggleStartTimeDropdown(i)" [class.disabled]="isSubmitting">
                      <span class="selected-value">{{ day.startTime }}</span>
                      <svg class="dropdown-arrow" [class.rotated]="openStartTimeDropdown === i" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
                      </svg>
                    </div>
                    <div class="dropdown-menu" [class.show]="openStartTimeDropdown === i">
                      <div class="dropdown-option" 
                           *ngFor="let time of timeOptions; trackBy: trackByValue" 
                           [class.selected]="day.startTime === time"
                           (click)="onDayStartTimeChange(i, time)">
                        {{ time }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="separator-cell">
                  <span class="time-separator">–</span>
                </div>
                <div class="end-time-cell">
                  <label class="mobile-label">End Time</label>
                  <div class="custom-dropdown" [class.disabled]="isSubmitting">
                    <div class="dropdown-selected" (click)="toggleEndTimeDropdown(i)" [class.disabled]="isSubmitting">
                      <span class="selected-value">{{ day.endTime }}</span>
                      <svg class="dropdown-arrow" [class.rotated]="openEndTimeDropdown === i" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
                      </svg>
                    </div>
                    <div class="dropdown-menu" [class.show]="openEndTimeDropdown === i">
                      <div class="dropdown-option" 
                           *ngFor="let time of timeOptions; trackBy: trackByValue" 
                           [class.selected]="day.endTime === time"
                           (click)="onDayEndTimeChange(i, time)">
                        {{ time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Divider after each day section (except last) -->
            <div class="section-divider" *ngIf="i < shiftForm.days.length - 1"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-buttons">
        <button class="btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button class="btn-primary" (click)="onSave()" [disabled]="isSubmitting || !shiftForm.shift_name.trim()">
          <span *ngIf="!isSubmitting">Save</span>
          <span *ngIf="isSubmitting">Saving...</span>
        </button>
      </div>
    </div>
  </div>
</div>
